import { getAdvancedParamValues, getSearchParamValue } from "../getParamValues";
import { UserConfig } from "../../state/UserStore";
import dayjs from "dayjs";
import { checkInvalidDate, formatDob, normalizeHitNoHit } from "../queryTransactionsHelpers";
import { getCurrentEnv } from "../getCurrentEnv";
import { QueryParams } from "../../interfaces/common";

const STATE = getCurrentEnv

export const generateQueryParams = (softLimit: string, pageName: string, userConfig: UserConfig, hardLimit: number, isAdmin, searchParams, filterLabels, orderBy, order, param): QueryParams => {
    console.log('debug getAdvancedParamValues generateQueryParams searchParams: ', { searchParams, param })

    console.log('debug query params days: ', {
        upperLimit: getAdvancedParamValues("upperDate", searchParams),
        days: dayjs().add(dayjs().diff(getAdvancedParamValues("upperDate", searchParams), "days"), 'days'),
        hardLimit,
        diff: dayjs().diff(getAdvancedParamValues("upperDate", searchParams), 'days')
    })

    console.log('DEBUG hitNoHit:', {
        searchParams,
        rawValue: searchParams?.get?.('hitNoHit') || searchParams?.hitNoHit,
        advancedValue: getAdvancedParamValues("hitNoHit", searchParams),
        normalizedValue: normalizeHitNoHit(getAdvancedParamValues("hitNoHit", searchParams))
    });

    const getDays = () => {
        let lowerDate = checkInvalidDate(getAdvancedParamValues("lowerDate", searchParams))
        let upperDate = checkInvalidDate(getAdvancedParamValues("upperDate", searchParams))
        console.log(`101010101 debug getParamValue getDays: `, { upperDate, lowerDate })
        if (lowerDate !== 'null') {
            console.log(`101010101 debug getParamValue getDays returns: `, dayjs().diff(lowerDate, 'days'))
            return (dayjs().diff(lowerDate, 'days') + 1).toString()
        } else {
            console.log(`101010101 debug getParamValue getDays returns: `, hardLimit)
            return hardLimit.toString()
        }
    }

    return [
        {
            "name": "type",
            "value": "Original"
        },
        {
            "name": "selectedTransactionStatus",
            "value": JSON.stringify(filterLabels)
        },
        {
            "value": isAdmin,
            "name": "isAdmin"
        },
        {
            "value": getDays(),
            "name": "days"
        },
        {
            "value": orderBy,
            "name": "orderBy"
        },
        {
            "value": getAdvancedParamValues("firstName", searchParams),
            "name": "firstName"
        },
        {
            "value": getAdvancedParamValues("middleName", searchParams),
            "name": "middleName"
        },
        {
            "value": getAdvancedParamValues("lastName", searchParams),
            "name": "lastName"
        },
        {
            "value": getAdvancedParamValues("fullName", searchParams),
            "name": "fullName"
        },
        {
            "value": getAdvancedParamValues("ueid", searchParams),
            "name": "ueid"
        },
        {
            "value": getAdvancedParamValues("tcn", searchParams),
            "name": "tcn"
        },
        {
            "value": getAdvancedParamValues("tot", searchParams),
            "name": "tot"
        },
        {
            "value": getAdvancedParamValues((STATE === "ga" || STATE === "mc") ? "stateRFPCode" : "rfp", searchParams),
            "name": (STATE === "ga" || STATE === "mc") ? "stateRFPCode" : "rfp"
        },
        ...STATE === "ga" || STATE === "mc" ? [{
            "value": getAdvancedParamValues("stateRFPLiteral", searchParams),
            "name": "stateRFPLiteral"
        }] : [],
        {
            "value": getAdvancedParamValues("agency", searchParams),
            "name": "ori"
        },
        {
            "value": normalizeHitNoHit(getSearchParamValue("hitNoHit", searchParams)),
            "name": "hitNoHit"
        },
        {
            "value": getAdvancedParamValues("ssn", searchParams),
            "name": "ssn"
        },
        {
            "value": "null",
            "name": "dob"
        },
        {
            "value": param?.column === "dob"
                ? getAdvancedParamValues("dob", searchParams, "lowerDobDate", pageName)
                : getAdvancedParamValues("lowerDobDate", searchParams),
            "name": "lowerDobDate"
        },
        {
            "value": param?.column === "dob"
                ? getAdvancedParamValues("dob", searchParams, "upperDobDate", pageName)
                : getAdvancedParamValues("upperDobDate", searchParams),
            "name": "upperDobDate"
        },
        {
            "value": getAdvancedParamValues("gender", searchParams),
            "name": "gender"
        },
        {
            "value": getAdvancedParamValues("race", searchParams),
            "name": "race"
        },
        {
            "value": getAdvancedParamValues("secondaryOri", searchParams),
            "name": "secondaryOri"
        },
        {
            "value": getAdvancedParamValues("status", searchParams),
            "name": "transactionStatus"
        },
        {
            "value": param?.column === "transactionDate"
                ? checkInvalidDate(getAdvancedParamValues("transactionDate", searchParams, "lowerDate", pageName))
                : checkInvalidDate(getAdvancedParamValues("lowerDate", searchParams)),
            "name": "lowerDate"
        },
        {
            "value": param?.column === "transactionDate"
                ? checkInvalidDate(getAdvancedParamValues("transactionDate", searchParams, "upperDate", pageName))
                : checkInvalidDate(getAdvancedParamValues("upperDate", searchParams)),
            "name": "upperDate"
        },
        {
            "value": getAdvancedParamValues("singleDate", searchParams),
            "name": "singleDate"
        },
        {
            "value": getAdvancedParamValues("rbSub", searchParams),
            "name": "rbSub"
        }
    ]
}